import React from "react";
import { Link } from "react-router-dom";
import { useStores } from "_common/hooks";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

export default function Security() {
  const {
    authStore: { user },
  } = useStores();

  return (
    <div className="container !mt-[75px]">
      <HeaderTop title="Đổi mật khẩu" />
      <div className="no_content">
        <div className="no_inbox">
          <Link to="/member/change-password">
            <div className="lbox">
              <div className="lbox_l">
                <span className="fcc fe6im fzmmm !text-[14px]">
                  &nbsp;&nbsp;Mật khẩu đăng nhập
                </span>
              </div>
              <div className="lbox_r">
                <FontAwesomeIcon icon={faChevronRight} color="#707A8A" />
              </div>
            </div>
          </Link>
          <Link to="/member/wallet-password">
            <div className="lbox">
              <div className="lbox_l">
                <span className="fcc fzmmm fe6im !text-[14px]">
                  &nbsp;&nbsp;Mật khẩu rút tiền
                </span>
              </div>
              <div className="lbox_r">
                <span className="f12  rzred">Không được thiết lập</span>
                <FontAwesomeIcon icon={faChevronRight} color="#707A8A" />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
